import ApplicationController from './application_controller'

export default class extends ApplicationController {
  blobToFile(theBlob, fileName) {
    return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
  }

  resizePhotos(settings) {
    const file = settings.file
    const maxFileSize = 5 * 1024 * 1024
    const reader = new FileReader()
    const image = new Image()
    const canvas = document.createElement('canvas')

    const dataURItoBlob = (dataURI) => {
      const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
        ? atob(dataURI.split(',')[1])
        : unescape(dataURI.split(',')[1])
      const mime = dataURI.split(',')[0].split(':')[1].split(';')[0]
      const max = bytes.length
      const ia = new Uint8Array(max)
      for (var i = 0; i < max; i++) { ia[i] = bytes.charCodeAt(i) }
      return new Blob([ia], { type: mime })
    }

    const resize = () => {
      let width = image.width
      let height = image.height
      const maxDimension = 2000

      if (width > height) {
        if (width > maxDimension) {
          height *= maxDimension / width
          width = maxDimension
        }
      } else {
        if (height > maxDimension) {
          width *= maxDimension / height
          height = maxDimension
        }
      }

      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')

      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'
      ctx.drawImage(image, 0, 0, width, height)

      let quality = 0.95
      let dataUrl
      let blob

      do {
        dataUrl = canvas.toDataURL('image/jpeg', quality)
        blob = dataURItoBlob(dataUrl)
        quality -= 0.05
      } while (blob.size > maxFileSize && quality > 0.5)

      return blob
    }

    return new Promise(function (ok, no) {
      if (!file.type.match(/image.*/)) {
        no(new Error('Not an image'))
        return
      }
      reader.onload = function (readerEvent) {
        image.onload = function () { return ok(resize()) }
        image.src = readerEvent.target.result
      }
      reader.readAsDataURL(file)
    })
  }

  async addToFormData(formData, array, requestValue) {
    for (let i = 0; i < array.length; i++) {
      const maxFileSize = 5 * 1024 * 1024
      if (array[i].size > maxFileSize) {
        const config = {
          file: array[i],
          maxSize: 2000
        }
        const resizedImage = await this.resizePhotos(config)
        const newImage = this.blobToFile(resizedImage, array[i].name)
        formData.append(requestValue, newImage, newImage.name)
      } else {
        formData.append(requestValue, array[i], array[i].name)
      }
    }
    return formData
  }
}
